import { useEffect, useState } from 'react';

import { IListUsersParams } from '../services/identity/listAllUsers';
import { listCareAdvisorUsers } from '../services/identity/listCareAdvisorUsers';
import { UserProfile } from '../services/identity/types/UserProfile';

interface IUseCareAdvisorUsers {
  users: UserProfile[];
  dataLoading: boolean;
  totalRecords: number;
  currentPage: number;
  setCurrentPage: React.Dispatch<React.SetStateAction<number>>;
}

export default function useCareAdvisorUsers(
  params: Pick<
    IListUsersParams,
    | 'sort_by'
    | 'sort_direction'
    | 'full_name'
    | 'email'
    | 'external_id'
    | 'id'
    | 'status'
    | 'type'
    | 'limit'
    | 'organization_ids'
    | 'client_tags'
    | 'client_division_ids'
    | 'page'
    | 'skip'
    | 'date_of_birth_start'
    | 'date_of_birth_end'
  >,
): IUseCareAdvisorUsers {
  const [users, setUsers] = useState<UserProfile[]>([]);
  const [totalRecords, setTotalRecords] = useState<number>(0);
  const [dataLoading, setDataLoading] = useState<boolean>(false);
  const [currentPage, setCurrentPage] = useState(1);

  useEffect(() => {
    setDataLoading(true);
    let canceled = false;

    listCareAdvisorUsers(params)
      .then((usersList) => {
        if (!canceled) {
          setTotalRecords(usersList.total);
          setUsers([...usersList.nodes]);
          setDataLoading(false);
        }
      })
      .catch(() => {
        if (!canceled) {
          setUsers([]);
          setTotalRecords(0);
          setDataLoading(false);
        }
      });

    return (): void => {
      canceled = true;
    };
  }, [params]);

  useEffect(() => {
    setCurrentPage(1);
  }, [params.full_name, params.email, params.external_id, params.id, params.status, params.type]);

  return {
    users,
    totalRecords,
    dataLoading,
    currentPage,
    setCurrentPage,
  };
}
